export const states = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
    'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
    'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

export const countries = [
    { code: 'US', name: 'United States' },
    { code: 'CA', name: 'Canada' }
];

export const GIFT_AMOUNTS = [
    { id: '1', amount: '1,000' },
    { id: '2', amount: '2,500' },
    { id: '3', amount: '5,000' },
    { id: '4', amount: '7,500' },
    { id: '5', amount: '10,000' }
];

export const DELIVERY_METHODS = {
    OVERNIGHT: 'overnight',
    EMAIL: 'email',
    BOTH: 'both'
};
